import { LAYOUT_EXPERIMENT } from '../../constants/experiments';
import { IApplicationState } from '../../types/redux';

export const layoutsEnabledSelector = (state: IApplicationState): boolean => {
  const { isLayoutsEnabled } = state;

  return isLayoutsEnabled;
};

export const layoutExperimentSelector = (state: IApplicationState): boolean => {
  const { abUseExperiments, isLayoutsEnabled } = state;

  const experiment = abUseExperiments.find(e => e.experimentName === LAYOUT_EXPERIMENT);

  if (!experiment) {
    return false;
  }

  return experiment.groupName === 'B' && isLayoutsEnabled;
};

export const layoutExperimentInAnyGroupSelector = (state: IApplicationState): boolean => {
  const { abUseExperiments } = state;

  const experiment = abUseExperiments.find(e => e.experimentName === LAYOUT_EXPERIMENT);

  if (!experiment) {
    return false;
  }

  return ['A', 'B'].includes(experiment.groupName as string);
};
